import type { AxiosInstance } from 'axios';

import type { ApiEventsRequest } from './trackingRequests';

import getDirectPersonalizationEventsAxiosClient from './directPersonalizationEventsAxiosClient';

export const trackingDirectApiUrls = {
    events: () => '/events',
};

const prepareEventRequestParams = (
    storeId: string | undefined,
    customerGroups: string[],
    device: string,
) => {
    const requestParams = {
        store: storeId,
        groups: customerGroups && !!customerGroups.length ? customerGroups.join(',') : null,
        device,
    };

    return requestParams;
};

type GetEventsClient = typeof getDirectPersonalizationEventsAxiosClient;

export const createTrackingDirectApi = (
    getClient: GetEventsClient = getDirectPersonalizationEventsAxiosClient,
) => ({
    track: async (eventRequest: ApiEventsRequest, device: string) => {
        const client: AxiosInstance = getClient();
        await client.post(trackingDirectApiUrls.events(), eventRequest, {
            params: prepareEventRequestParams(undefined, [], device),
        });
    },
});

const trackingDirectApi = createTrackingDirectApi();

export default trackingDirectApi;
